import { Component } from '@angular/core';
import { ListRendererWidgetBase } from '@capturum/builders/list-renderer';

@Component({
    selector: 'app-installer-category-widget',
    templateUrl: './installer-category-widget.component.html',
    styleUrls: ['./installer-category-widget.component.scss'],
    standalone: false
})
export class InstallerCategoryWidgetComponent extends ListRendererWidgetBase {}
